import _ from "lodash";
import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import {
  cardStyles,
  modalGenericStyles,
  variables,
} from "../../../../../variables";
import { retrieveBranch } from "../../../../../api/CRM/Branches/Branches";
import PropTypes from "prop-types";
import { DateTime } from "luxon";
import { AddressesCard } from "../../../../../components/cards";
import { ContactsCard } from "../../../../../components/cards/contacts";
import GenericBasicInfo from "../../../../../components/cards/GenericBasicInfo";
import EntityPreferences from "../../../../../components/Entity/entity_preferences";
import { CommentsCard } from "../../../../../components/cards/comments";
import DepositStatments from "../../../CommonCRMModals/DepositStatmentss/DepositStatment";
import { DocumentsCard } from "../../../CommonCRMModals/Documents";
import { useQuery } from "@tanstack/react-query";
import { genericRequestErrorHandler } from "../../../../../api";
import Loader from "../../../../../components/Loader";
import CRMTravelServicesTable from "../../../CommonCRMModals/CRMTravelServicesTable";
import CRMGroupsTable from "../../../CommonCRMModals/CRMGroups";
import TabStrip from "../../../../../components/TabStrip";
import { CustomButton } from "../../../../../components/CustomButton";
import BranchLogsTab from "./BranchLogsTab";
import BranchBuyingStatments from "../../BranchBuyingStatments";

const b2cVivaCredentialsType = {
  "": "-----",
  LV: "Live",
  DE: "Demo",
};

const detailBranchModal = createUseStyles({
  ...modalGenericStyles,
  DetailBranchesModal: {
    ...modalGenericStyles.modal,
    overflow: "auto",
  },
  modalCard: {
    ...modalGenericStyles.card,
    gridTemplateRows: "max-content max-content 1fr max-content",
  },
  modalCardHeader: {
    ...modalGenericStyles.cardHeader,
  },
  modalCardBody: {
    ...modalGenericStyles.cardBody,
    display: "grid",
  },
  modalCardActions: {
    ...modalGenericStyles.cardActions,
  },
  card: { ...cardStyles.card, maxWidth: "100%" },
  cardHeader: cardStyles.header,
  cardBody: {
    ...cardStyles.body,
    gap: variables.normal_gap,
    maxWidth: "100%",
    overflow: "hidden",
  },
  firstRow: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gridGap: variables.normal_gap,
    justifyContent: "left",
  },
  basicInfoCardBody: {
    extend: "cardBody",
  },
  basicInfoRightDetailsRowCardBody: {
    ...cardStyles.body,
    display: "grid",
    width: "100%",
    justifySelf: "center",
    justifyItems: "center",
    gridTemplateColumns: "repeat(1, 1fr)",
    gap: variables.double_gap,
    alignContent: "start",
  },
  seconRowcardBody: {
    extend: "cardBody",
    maxHeight: "15rem",
  },

  [`@media ${variables.media.smallscreen}`]: {
    firstRow: {
      gridTemplateColumns: "1fr 1fr",
    },
    basicInfoRightDetailsRowCardBody: {
      gridTemplateColumns: "repeat(3, 1fr)",
    },
  },
  [`@media ${variables.media.bigscreen}`]: {
    firstRow: {
      gridTemplateColumns: "1fr 1fr",
    },
  },
});
const DetailBranchModal = ({ branchId, onClose }) => {
  const classes = detailBranchModal();

  const [activeTab, setActiveTab] = useState("basicInfo");

  const { data: branch, isLoading: loading } = useQuery({
    queryKey: ["DetailBranchModal", branchId],
    queryFn: async () => await retrieveBranch({ id: branchId }),
    onError: (error) => genericRequestErrorHandler(error),
  });

  const getWorkingDays = (weekdays) => {
    let workingDays = [];
    weekdays ||
      [].forEach((weekDay, idx) => {
        let day = "";
        switch (idx) {
          case 0:
            if (weekdays[idx]) {
              day = "Monday";
            }
            break;
          case 1:
            if (weekdays[idx]) {
              day = "Tuesday ";
            }
            break;
          case 2:
            if (weekdays[idx]) {
              day = "Wednesday";
            }
            break;
          case 3:
            if (weekdays[idx]) {
              day = "Thursday";
            }
            break;
          case 4:
            if (weekdays[idx]) {
              day = "Friday";
            }
            break;
          case 5:
            if (weekdays[idx]) {
              day = "Saturday";
            }
            break;
          case 6:
            if (weekdays[idx]) {
              day = "Sunday";
            }
            break;
          default:
            day = "";
            break;
        }
        if (day) {
          workingDays.push(day);
        }
      });
    return workingDays;
  };

  const basicDataCpl = [
    ["Business Name", null, _.capitalize(_.get(branch, "data.name"))],
    ["Member", "member"],
    ["Legal Title", "legal_title"],
    ["Registration Code", "registration_code"],
    ["Founding Year", "founding_year"],
    ["Contact Email", null, _.get(branch, "data.contact_persons.0.email")],
    ["Mobile Phone", "mobile_phone"],
    ["Phone", "phone"],
    ["B2C Viva Credentials Type", "b2c_viva_credentials_type"],
    ["Completeness", "completeness"],
    ["Email", "email"],
    ["Url", "url"],
    ["Currency", "currency"],
    [
      "Created",
      null,
      DateTime.fromISO(_.get(branch, "data.created")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
  ];

  const PaymentGatewayCredentialsCpls = [
    ["Felloh Organisation", "felloh_organisation"],
    [
      "Felloh environment",
      null,
      _.startCase(_.get(branch, "data.felloh_environment")),
    ],
    ["Felloh Public Key", "felloh_public_key"],
    ["Felloh Secret Key", "felloh_secret_key"],
    ["B2C Stripe Accepted Coupons", "b2c_stripe_accepted_coupons"],
    ["b2c Stripe API Public Key", "b2c_stripe_api_public_key"],
    ["B2C Stripe API Secret Key", "b2c_stripe_api_secret_key"],
    ["B2C Viva API Key", "b2c_viva_api_key"],
    [
      "B2C Viva Credentials Type",
      null,
      _.get(
        b2cVivaCredentialsType,
        _.get(branch, "data.b2c_viva_credentials_type", "") || "N/A"
      ),
    ],
    ["B2C Viva Merchant Id", "b2c_viva_source_code"],
    ["Barclays Passphrase", "barclays_passphrase"],
    ["Barclays Passphrase", "barclays_passphrase"],
    ["Barclays Pspid", "barclays_pspid"],
  ];

  const basicCpl = [
    ["Timezone", "timezone"],
    [
      "Days",
      null,
      getWorkingDays(_.get(branch, "data.weekdays", [])).join(", "),
    ],
  ];

  const menuTabs = {
    basicInfo: "Basic Info",
    comments: "Comments",
    buyingStatment: "Buying Statment",
    // creditStatment: "Credit Statment",
    logs: "Logs",
    // documents: "Documents",
  };

  return (
    <div id="DetailBranchModal" className={classes.DetailBranchesModal}>
      {loading ? (
        <div className={classes.modalCard}>
          <div className={classes.modalCardHeader}>
            <span>Branch Details</span>
          </div>
          <div className={classes.modalCardBody}>
            <Loader />
          </div>
        </div>
      ) : (
        <div className={classes.modalCard}>
          <div className={classes.modalCardHeader}>
            <span>Branch Details</span>
          </div>
          <TabStrip
            tabs={Object.entries(menuTabs)}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <div className={classes.modalCardBody}>
            {activeTab === "basicInfo" && (
              <React.Fragment>
                <div className={classes.card}>
                  <div className={classes.firstRow}>
                    <div className={classes.basicInfoCardBody}>
                      <GenericBasicInfo
                        header="Basic Data"
                        cardInfo={basicDataCpl}
                        objectData={_.get(branch, "data", [])}
                      />
                    </div>

                    <div className={classes.basicInfoCardBody}>
                      <GenericBasicInfo
                        header="Payment Gateway Credentials"
                        cardInfo={PaymentGatewayCredentialsCpls}
                        objectData={_.get(branch, "data", [])}
                      />
                    </div>
                  </div>
                </div>
                <div className={classes.card}>
                  <div className={classes.basicInfoRightDetailsRowCardBody}>
                    <div className={classes.seconRowcardBody}>
                      <GenericBasicInfo
                        header="Profile Operation Time"
                        cardInfo={basicCpl}
                        objectData={_.get(branch, "data", [])}
                        custonStyles={{ header: { width: "100%" } }}
                      />
                    </div>
                    <div className={classes.seconRowcardBody}>
                      <CRMTravelServicesTable
                        data={_.get(branch, "data.travel_services_display", [])}
                      />
                    </div>
                    <div className={classes.seconRowcardBody}>
                      <CRMGroupsTable
                        data={_.get(branch, "data.groups_display", [])}
                      />
                    </div>
                  </div>
                </div>
                <EntityPreferences entity={_.get(branch, "data", [])} />
                <AddressesCard
                  addresses={_.get(branch, "data.addresses", [])}
                />
                <ContactsCard
                  contacts={_.get(branch, "data.contact_persons", [])}
                />
              </React.Fragment>
            )}
            {activeTab === "comments" && (
              <CommentsCard
                title="Comments"
                id={branchId}
                entityType="branch"
              />
            )}
            {activeTab === "buyingStatment" && (
              <BranchBuyingStatments
                entityType="branch"
                entityData={_.get(branch, "data", {})}
              />
            )}
            {activeTab === "creditStatment" && (
              <DepositStatments
                invalidationKey="DetailBranchModal"
                entityType="branch"
                entityData={_.get(branch, "data", {})}
              />
            )}
            {activeTab === "documents" && (
              <DocumentsCard
                title="Documents"
                id={branchId}
                showAddButton={true}
                sourceEntity={`${branchId}___branch`}
              />
            )}
            {activeTab === "logs" && <BranchLogsTab />}
          </div>
          <div className={classes.cardActions}>
            <CustomButton id="cancel" appearance="ghost" onClick={onClose}>
              <strong>Close</strong>
            </CustomButton>
          </div>
        </div>
      )}
    </div>
  );
};
DetailBranchModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default DetailBranchModal;
